import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { Device } from "src/sections/dashboard/software/useGitHubStats";
import type { MouseEvent } from "react";

export interface Filters {
  name?: string;
  category: string[];
  status: string[];
  inStock?: boolean;
  devices: Device[];
}

export interface SoftwareSearchState {
  filters: Filters;
  page: number;
  rowsPerPage: number;
}

export const useSoftwareSearch = () => {
  const [state, setState] = useState<SoftwareSearchState>(() => {
    const savedState = localStorage.getItem("softwareFilters");
    return savedState
      ? JSON.parse(savedState)
      : {
          filters: {
            name: undefined,
            category: [],
            status: [],
            inStock: undefined,
            devices: ["web", "ios", "android", "web/desktop"],
          },
          page: 0,
          rowsPerPage: 5,
        };
  });

  useEffect(() => {
    localStorage.setItem("softwareFilters", JSON.stringify(state));
  }, [state]);

  const handleFiltersChange = useCallback((filters: Filters): void => {
    setState((prevState) => ({
      ...prevState,
      filters,
    }));
  }, []);

  const handlePageChange = useCallback(
    (event: MouseEvent<HTMLButtonElement> | null, page: number): void => {
      setState((prevState) => ({
        ...prevState,
        page,
      }));
    },
    []
  );

  const handleRowsPerPageChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>): void => {
      setState((prevState) => ({
        ...prevState,
        rowsPerPage: parseInt(event.target.value, 10),
      }));
    },
    []
  );

  return {
    handleFiltersChange,
    handlePageChange,
    handleRowsPerPageChange,
    state,
  };
};
